import { FC } from "react";
import { Avatar, Box, Callout, Flex, Heading, Text } from "@radix-ui/themes";
import { Profile } from "@/models/database/profiles/profile.model";

const RaffleUIItem: FC<any> = ({ ...props }): JSX.Element => {
  const userName = props.userName;
  const email = props.email;

  return (
    <Flex direction="column" gap="4">
      <Callout.Root variant="outline" size="1" style={{ display: "flex" }}>
        <Box width="100%" minWidth="100%" gridColumn="1 / -1">
          <Flex align="center" justify="start" gap="5" wrap="wrap">
            {/* User */}
            <Flex
              align="center"
              gap="3"
              maxWidth={{ initial: "150px", lg: "none" }}
            >
              {/* Avatar */}
              <Avatar
                src={props.profileLogoUrl}
                fallback={userName ? userName.slice(0, 1) : "U"}
                radius="full"
                size="3"
              />

              <Box maxWidth="100%">
                {/* Username */}
                {userName && (
                  <Heading as="h4" size="3" my="0" truncate>
                    {userName}
                  </Heading>
                )}

                {/* Email */}
                {email && (
                  <Text size="2" color="gray" my="0" truncate>
                    {email}
                  </Text>
                )}
              </Box>
            </Flex>
          </Flex>
        </Box>
      </Callout.Root>
    </Flex>
  );
};

export default RaffleUIItem;
